import { isCapacitorNative } from './nativeGoogleAuth';

function getStatusBarPlugin() {
  if (typeof window === 'undefined') return null;
  return window.Capacitor?.Plugins?.StatusBar ?? null;
}

async function applyNativeStatusBarStyle() {
  const StatusBar = getStatusBarPlugin();
  if (!StatusBar) return;

  try {
    if (StatusBar.setOverlaysWebView) {
      await StatusBar.setOverlaysWebView({ overlay: false });
    }
    if (StatusBar.setBackgroundColor) {
      await StatusBar.setBackgroundColor({ color: '#ffffff' });
    }
    // DARK = dark icons on light background (Capacitor naming).
    if (StatusBar.setStyle) {
      await StatusBar.setStyle({ style: 'DARK' });
    }
    if (StatusBar.show) {
      await StatusBar.show();
    }
  } catch (error) {
    console.warn('[nativeStatusBar] apply failed:', error);
  }
}

let resumeListenerAttached = false;

/** Keep system status bar visible on Capacitor (Android/iOS). */
export async function initNativeStatusBar() {
  if (!isCapacitorNative()) return;

  await applyNativeStatusBarStyle();

  if (typeof document !== 'undefined' && !resumeListenerAttached) {
    resumeListenerAttached = true;
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        applyNativeStatusBarStyle();
      }
    });
  }
}
